var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "studio-page-header",
        class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
        staticStyle: {
          "padding-bottom": "0 !important",
          "padding-top": "15px !important",
          height: "110px"
        }
      },
      [
        _c("div", { staticClass: "title-tab-experience-manager" }, [
          _vm._v("ADMINISTRATOR")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex m__t--45" },
          [
            _vm._l(_vm.tabMenu, function(tab, index) {
              return [
                tab.show
                  ? _c(
                      "div",
                      {
                        key: tab.label,
                        class: [
                          { "m__r--35": index < _vm.tabMenu.length - 1 },
                          tab.active
                            ? "tab-experience-manager-active"
                            : "tab-experience-manager"
                        ],
                        on: {
                          click: function($event) {
                            _vm.$router.replace(tab.url)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(tab.label) + "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "studio-page-administrator-content" }, [
      _c(
        "div",
        { staticClass: "custom-table-search" },
        [
          _c(
            "v-server-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.load_first,
                  expression: "load_first"
                }
              ],
              ref: "tableLocation",
              staticClass: "jTable",
              attrs: { columns: _vm.columns, options: _vm.options },
              on: {
                loading: _vm.loading,
                loaded: _vm.loaded,
                "row-click": _vm.onRowClick
              },
              scopedSlots: _vm._u([
                {
                  key: "pic",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.row.organigram.name) +
                          "\n        "
                      )
                    ])
                  }
                },
                {
                  key: "created_date",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("moment")(
                              props.row.created_date,
                              "MMM DD, YYYY"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  }
                },
                {
                  key: "updated_date",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("moment")(
                              props.row.updated_date,
                              "MMM DD, YYYY"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.filter(_vm.filter_data)
                        }
                      }
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-import-oos m__r--5",
                          on: { click: _vm.createLocationButton }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-lg" }),
                          _vm._v(" Add\n            ")
                        ]
                      ),
                      _vm._v(" "),
                      _vm.default_import
                        ? _c("j-import-file-oos", {
                            attrs: {
                              "href-sample": require("@/assets/file/create-location.xlsx")
                            },
                            on: { "import-data": _vm.importData }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("j-select", {
                        staticClass: "m__r--5",
                        attrs: {
                          disabled: false,
                          options: _vm.options_search,
                          placeholder: "Filter By"
                        },
                        model: {
                          value: _vm.select_type,
                          callback: function($$v) {
                            _vm.select_type = $$v
                          },
                          expression: "select_type"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("b-form-input", {
                            ref: "filterInput",
                            staticClass: "m__r--5",
                            attrs: { placeholder: "Search" },
                            model: {
                              value: _vm.filter_data,
                              callback: function($$v) {
                                _vm.filter_data = $$v
                              },
                              expression: "filter_data"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("j-progress-screen", {
            ref: "ImportFile",
            attrs: {
              "data-kirim": _vm.data_import,
              "url-api": _vm.url,
              headers: _vm.headers,
              "property-data": "data"
            },
            on: { finish: _vm.uploadDone }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54c8530c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c8530c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/location/jListCompanyLocation.vue
// module id = null
// module chunks = 